import { useTranslation } from 'next-i18next';
import { ImageNotFoundIcon } from '@/icons/components/ImageNotFound';
import { ImageInputButton } from './ImageInputButton';
import { useDroppableImageUpload } from './useDroppableImageUpload';
export const SearchNotFoundScreen = ({
  onUploadStart,
  imageUrl
}: {
  onUploadStart: (file: File) => void;
  imageUrl?: string;
}) => {
  const {
    inputRef,
    inputProps
  } = useDroppableImageUpload({
    onUploadStart,
    imageUrl
  });
  return <div className="flex size-full flex-col items-center justify-between pt-2xl" data-sentry-component="SearchNotFoundScreen" data-sentry-source-file="SearchNotFoundScreen.tsx">
      <div className="flex flex-col items-center gap-md">
        <SearchNotFoundScreen.Content data-sentry-element="unknown" data-sentry-source-file="SearchNotFoundScreen.tsx" />
        <ImageInputButton onClick={() => inputRef.current?.click()} data-sentry-element="ImageInputButton" data-sentry-source-file="SearchNotFoundScreen.tsx" />
      </div>
      <input {...inputProps} className="hidden" ref={inputRef} />
    </div>;
};
const Content = () => {
  const {
    t
  } = useTranslation(['build']);
  return <div className="flex flex-col items-center gap-xs" data-sentry-component="Content" data-sentry-source-file="SearchNotFoundScreen.tsx">
      <ImageNotFoundIcon fill={'#E4E4E4'} className="mb-4xs ml-xs h-[97px] w-[106px]" data-sentry-element="ImageNotFoundIcon" data-sentry-source-file="SearchNotFoundScreen.tsx" />
      <div className="flex flex-col items-center gap-xs pb-4xs pt-3xs">
        <span className="text-heading-md-bold text-neutral">
          {t('image.notFound.title')}
        </span>
        <span className="text-body-lg-medium text-assistive">
          {t('image.notFound.description')}
        </span>
      </div>
    </div>;
};
SearchNotFoundScreen.Content = Content;